import React, { useState } from "react";
import Arrow from "../../assets/svg/Arrow.svg";
import delivery from "../../assets/svg/delivery.svg";
import amount from "../../assets/svg/sales-amount.svg";
import galon from "../../assets/svg/galon.Icon.svg";
import batary from "../../assets/svg/batary.svg";
import CarWosh from "../../assets/svg/CarWosh.icon.svg";
import Services from "../../assets/svg/Services Icons (1).svg";
import Tire from "../../assets/svg/Services Icons (2).svg";
import execued from "../../assets/svg/execued.icon.svg";
import cancelled from "../../assets/svg/cancelled.icon.svg";

function Overview_ClentInfo() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);

  return (
    <>
      <div className="DoorStep_Overview">
        <div className="DoorStep_Overview_front">
          <div className="DoorStep_Overview_title">DoorStep Overview</div>
          <div
            className="DoorStep_Overview_ShowDe"
            onClick={() => setIsOpen1(!isOpen1)}
          >
            <span>in 2024</span>
            <img
              className={isOpen1 ? "ArrDown_Open" : "ArrDown_Close"}
              src={Arrow}
              alt="Arrow"
            />
          </div>
        </div>
        <div className={`DoorStep_Overview_Back ${isOpen1 ? "open" : ""}`}>
          {[
            {
              id: 0,
              tile: "Total Orders",
              icons: delivery,
              total: "30 Orders",
            },
            {
              id: 1,
              tile: "Total Revenue",
              icons: amount,
              total: "80.000 EGP",
            },
          ].map((e) => {
            return (
              <div key={e.id} className="DoorStep_Overview_Back_TheBig">
                <div className="TheBig_title">
                  <img src={e.icons} alt="" />
                  <span>{e.tile}</span>
                </div>
                <div className="TheBig_Total">{e.total}</div>
                <div className="w-100">
                  <div className="TheBig_detales_title">
                    <div className="ff">
                      <div className="">
                        <img src={galon} alt="" />
                      </div>
                      <span>Oil & Filter orders</span>
                    </div>
                    <div className="dd">
                      <span>15 / </span>
                      30
                    </div>
                  </div>
                  <div className="TheBig_detales_value"></div>
                </div>
                <div className="w-100">
                  <div className="TheBig_detales_title">
                    <div className="ff">
                      <div className="">
                        <img src={batary} alt="" />
                      </div>
                      <span>Oil & Filter orders</span>
                    </div>
                    <div className="dd">
                      <span>15 / </span>
                      30
                    </div>
                  </div>
                  <div className="TheBig_detales_value"></div>
                </div>
                <div className="w-100">
                  <div className="TheBig_detales_title">
                    <div className="ff">
                      <div className="">
                        <img src={CarWosh} alt="" />
                      </div>
                      <span>Oil & Filter orders</span>
                    </div>
                    <div className="dd">
                      <span>15 / </span>
                      30
                    </div>
                  </div>
                  <div className="TheBig_detales_value"></div>
                </div>
                <div className="w-100">
                  <div className="TheBig_detales_title">
                    <div className="ff">
                      <div className="">
                        <img src={Services} alt="" />
                      </div>
                      <span>Oil & Filter orders</span>
                    </div>
                    <div className="dd">
                      <span>15 / </span>
                      30
                    </div>
                  </div>
                  <div className="TheBig_detales_value"></div>
                </div>
                <div className="w-100">
                  <div className="TheBig_detales_title">
                    <div className="ff">
                      <div className="">
                        <img src={Tire} alt="" />
                      </div>
                      <span>Oil & Filter orders</span>
                    </div>
                    <div className="dd">
                      <span>15 / </span>
                      30
                    </div>
                  </div>
                  <div className="TheBig_detales_value"></div>
                </div>
              </div>
            );
          })}
          {[
            {
              id: 0,
              icon: execued,
              iconTitle: "Executed Orders",
              des: "28 orders",
            },
            {
              id: 1,
              icon: cancelled,
              iconTitle: "Cancelled Orders",
              des: "2 orders",
            },
          ].map((e) => {
            return (
              <div key={e.id} className="DoorStep_Overview_Back_TheSmall">
                <div className={`titel_TheSmall ${e.id === 1 ? "red" : ""}`}>
                  <img src={e.icon} alt="" />
                  <span>{e.iconTitle}</span>
                </div>
                <div className="des_TheSmall">{e.des}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="DoorStep_Overview">
        <div className="DoorStep_Overview_front">
          <div className="DoorStep_Overview_title">
            Emergency Dervices Overview
          </div>
          <div
            className="DoorStep_Overview_ShowDe"
            onClick={() => setIsOpen2(!isOpen2)}
          >
            <span>in 2024</span>
            <img
              className={isOpen2 ? "ArrDown_Open" : "ArrDown_Close"}
              src={Arrow}
              alt="Arrow"
            />
          </div>
        </div>
        <div className={`menyDetals ${isOpen2 ? "open" : ""}`}>
          {[
            {
              id: 0,
              tile: "Total Orders",
              icons: delivery,
              total: "30 Orders",
            },
            {
              id: 1,
              tile: "Total Revenue",
              icons: amount,
              total: "80.000 EGP",
            },
          ].map((e) => {
            return (
              <div key={e.id} className="DoorStep_Overview_Back_TheBig">
                <div className="TheBig_title">
                  <img src={e.icons} alt="" />
                  <span>{e.tile}</span>
                </div>
                <div className="TheBig_Total">{e.total}</div>
              </div>
            );
          })}
          {[
            {
              id: 0,
              icon: execued,
              iconTitle: "Executed Orders",
              des: "28 orders",
            },
            {
              id: 1,
              icon: cancelled,
              iconTitle: "Cancelled Orders",
              des: "2 orders",
            },
          ].map((e) => {
            return (
              <div key={e.id} className="DoorStep_Overview_Back_TheSmall">
                <div className={`titel_TheSmall ${e.id === 1 ? "red" : ""}`}>
                  <img src={e.icon} alt="" />
                  <span>{e.iconTitle}</span>
                </div>
                <div className="des_TheSmall">{e.des}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="DoorStep_Overview">
        <div className="DoorStep_Overview_front">
          <div className="DoorStep_Overview_title">Spare Services Dverview</div>
          <div
            className="DoorStep_Overview_ShowDe"
            onClick={() => setIsOpen3(!isOpen3)}
          >
            <span>in 2024</span>
            <img
              className={isOpen3 ? "ArrDown_Open" : "ArrDown_Close"}
              src={Arrow}
              alt="Arrow"
            />
          </div>
        </div>
        <div className={`menyDetals ${isOpen3 ? "open" : ""}`}>
          {[
            {
              id: 0,
              tile: "Total Orders",
              icons: delivery,
              total: "30 Orders",
            },
            {
              id: 1,
              tile: "Total Revenue",
              icons: amount,
              total: "80.000 EGP",
            },
          ].map((e) => {
            return (
              <div key={e.id} className="DoorStep_Overview_Back_TheBig">
                <div className="TheBig_title">
                  <img src={e.icons} alt="" />
                  <span>{e.tile}</span>
                </div>
                <div className="TheBig_Total">{e.total}</div>
              </div>
            );
          })}
          {[
            {
              id: 0,
              icon: execued,
              iconTitle: "Executed Orders",
              des: "28 orders",
            },
            {
              id: 1,
              icon: cancelled,
              iconTitle: "Cancelled Orders",
              des: "2 orders",
            },
          ].map((e) => {
            return (
              <div key={e.id} className="DoorStep_Overview_Back_TheSmall">
                <div className={`titel_TheSmall ${e.id === 1 ? "red" : ""}`}>
                  <img src={e.icon} alt="" />
                  <span>{e.iconTitle}</span>
                </div>
                <div className="des_TheSmall">{e.des}</div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Overview_ClentInfo;
